const namespace = {
  title: "Similar neighborhoods",
  title_32: "Similar zip codes",
  title_37: "Similar counties",
  description:
    "Discover similar locations to this neighborhood and see how they compare in terms of characteristics and amenities.",
  descriptionWithNeighborhood:
    "Discover similar locations to {{neighborhoodName}} and see how they compare in terms of characteristics and amenities.",
  noData: "Similar neighborhoods are not available for this location.",
  tags: {
    negative: "Less affordable",
    neutral: "Comparable",
    positive: "More affordable",
  },
  pagination: {
    previous: "Show less",
    next: "Show more",
  },
} as const;

export default namespace;
